export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_STATS":
      return action.payload;
    case "UPDATE_STATS":
      return state.map((item) => {
        if (item.id !== action.payload.id) {
          return item;
        }
        return { ...item, ...action.payload };
      });
    case "REMOVE_STAT":
      return state.filter((item) => item.id !== action.payload);
    case "ADD_STAT":
      return [...state, action.payload];
    default:
      return state;
  }
};
